import { css, cx } from '@eti/styles';
import { useTranslation } from '@eti/providers';
import { price as priceUtils } from '@eti/utils';
import { breakpoints, Radio, RadioGroup, vars } from '@etg/wings';
import { getSeatingPreferenceOptions } from './SeatingLightOrBeside.utils';
import { screenReaderOnly } from '../../common/utils/styles';
import SegmentPanel from './SegmentPanel';
import { seatingPreferenceOptions } from '../constants/seatingPreferenceOptions';
import { seatingPreferenceValues } from '../constants/seatingPreferenceValues';
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
const radioStyles = css`
  align-items: center;
  border: 1px solid ${vars.colors.inputs.border};
  border-radius: 0.188rem;
  display: flex;
  height: 2.625rem;
  margin-bottom: 0.5rem;
  padding: 0.75rem;
  width: 100%;

  &:not(:last-child) {
    &.radio_option {
      margin-bottom: 0.5rem;
    }
  }

  .etiCustomRadio {
    position: relative;
  }

  @media (min-width: ${breakpoints._970}) {
    padding-left: 1rem;
  }

  html[dir='rtl'] & {
    padding-left: 1rem;
  }
`;
const priceStyles = css`
  flex-grow: 1;
  font-size: 0.875rem;
  font-weight: 700;
  margin: 0 0 0 auto;
  text-align: right;
  width: 30%;

  html[dir='rtl'] & {
    margin: 0.25rem auto 0 0;
    text-align: left;
  }
`;
const labelStyles = css`
  flex-grow: 1;
  font-size: 0.875rem;
  padding: 0 0.625rem;
`;
const SeatingLightOrBeside = ({
  activeSegment,
  carrier,
  typename: type = seatingPreferenceOptions.SELL_SEATING_BESIDE,
  price,
  onChangeSeatingLightBeside,
  selectedSeatPreference
}) => {
  var _selectedSeatPreferen, _selectedSeatPreferen2, _price$price$value, _price$price, _price$markup$value, _price$markup;
  const {
    t
  } = useTranslation();
  const options = getSeatingPreferenceOptions(type);
  const selectedPreference = (_selectedSeatPreferen = selectedSeatPreference === null || selectedSeatPreference === void 0 || (_selectedSeatPreferen2 = selectedSeatPreference[0]) === null || _selectedSeatPreferen2 === void 0 ? void 0 : _selectedSeatPreferen2.seatPreference) !== null && _selectedSeatPreferen !== void 0 ? _selectedSeatPreferen : null;
  const priceValue = (_price$price$value = price === null || price === void 0 || (_price$price = price.price) === null || _price$price === void 0 ? void 0 : _price$price.value) !== null && _price$price$value !== void 0 ? _price$price$value : 0;
  const priceMarkup = (_price$markup$value = price === null || price === void 0 || (_price$markup = price.markup) === null || _price$markup === void 0 ? void 0 : _price$markup.value) !== null && _price$markup$value !== void 0 ? _price$markup$value : 0;
  const onChangeHandler = (_event, value) => {
    const isRandomSeatPreference = value === seatingPreferenceValues.RANDOM;
    const segment = {
      carrier,
      boundSegmentIndex: activeSegment,
      price: isRandomSeatPreference ? 0 : priceValue,
      markup: isRandomSeatPreference ? 0 : priceMarkup,
      seatPreference: value
    };
    onChangeSeatingLightBeside(segment);
  };
  const getPrice = value => {
    if (!value || value === seatingPreferenceValues.RANDOM) {
      return 0;
    }
    return priceValue;
  };
  const seatingPreferenceType = type === seatingPreferenceOptions.SELL_SEATING_BESIDE ? 'SeatingBeside' : 'SeatingLight';
  const title = t(`Product.SeatMap.Segment.Unavailable.${seatingPreferenceType}.Title`);
  const content = t(`Product.SeatMap.Segment.Unavailable.${seatingPreferenceType}.Content`);
  const defaultIcons = [[{
    id: 'c_flat-seat-selected-blue',
    size: '32px'
  }], [{
    id: 'c_flat-seat-selected-blue',
    size: '32px'
  }]];
  const icons = type === seatingPreferenceOptions.SELL_SEATING_BESIDE ? defaultIcons : [...defaultIcons, [{
    id: 'c_flat-seat-preference',
    height: '18px',
    width: '12px',
    top: '4px'
  }]];
  return /*#__PURE__*/_jsxs(RadioGroup, {
    "data-testid": `seatMap-seatingCombo-${type}`,
    name: `${activeSegment}.traveler0.seatPreference`,
    onChange: event => onChangeHandler(event, event === null || event === void 0 ? void 0 : event.target.value),
    selectedValue: selectedPreference,
    children: [/*#__PURE__*/_jsxs(RadioGroup.Legend, {
      className: screenReaderOnly,
      children: [title, content]
    }), /*#__PURE__*/_jsx(SegmentPanel, {
      content: content,
      icons: icons,
      title: title,
      children: options.map(({
        label,
        value,
        id
      }) => /*#__PURE__*/_jsxs(Radio.Label, {
        className: cx('radio_option', radioStyles),
        htmlFor: id,
        children: [/*#__PURE__*/_jsx(Radio, {
          "data-testid": `seating-combo-${id}`,
          id: id,
          tabIndex: 0,
          value: value
        }), /*#__PURE__*/_jsx("span", {
          className: labelStyles,
          children: t(label)
        }), /*#__PURE__*/_jsx("span", {
          className: priceStyles,
          children: priceUtils.formatPrice(getPrice(value))
        })]
      }, id))
    })]
  });
};
export default SeatingLightOrBeside;
//# sourceMappingURL=SeatingLightOrBeside.js.map